import { Asterisk } from "lucide-react";

const ITEMS = [
  "Less paperwork",
  "Less repetition",
  "Less chasing",
  "More control",
  "One simple system",
  "Customer to paid",
];

export default function EditorialMarquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span className="font-display font-bold text-2xl sm:text-4xl tracking-tight text-brand-tealsoft/90 whitespace-nowrap px-6 sm:px-10">
            {item}
          </span>
          <Asterisk className="text-brand-gold shrink-0" size={22} />
        </span>
      ))}
    </div>
  );

  return (
    <section
      data-testid="editorial-marquee-container"
      aria-hidden="true"
      className="bg-brand-navy py-8 sm:py-10 overflow-hidden select-none"
    >
      <div className="od-marquee-track flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </section>
  );
}
